module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "specials Other",
    attrs: {
      "id": "section_other--num_1--seq_5"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_114619-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_114619-00001"
    }
  }, [_c('h1', [_vm._v("MISTRESS "), _c('br'), _vm._v("BELOW DECK")])])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_114619-00002"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc8a434a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781408913727_other_01.vue
// module id = 66
// module chunks = 0